import { render } from "./ModalCreateServer.vue?vue&type=template&id=37689246&scoped=true&ts=true"
import script from "./ModalCreateServer.vue?vue&type=script&lang=ts"
export * from "./ModalCreateServer.vue?vue&type=script&lang=ts"

import "./ModalCreateServer.vue?vue&type=style&index=0&id=37689246&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37689246"]])

export default __exports__